import React, { useEffect, useCallback } from 'react';
import { TrackingProvider, PageView } from '@justgiving/react-tracking';
import { loadClient } from '@justgiving/chrome';
import analytics from '../../utils/analytics';
import useBasePageQuery from '../../hooks/useBasePageQuery';

const baseTrackingData = {};

const Page: React.FunctionComponent = ({ children }) => {
  const basePageData = useBasePageQuery();

  const headerimage = basePageData?.data?.page?.branding?.headerImage;

  const campaignPageRelationships =
    basePageData?.data?.page?.relationships?.campaigns.nodes[0];
  const isJGPro = campaignPageRelationships?.isJGPro; // TODO: update this once isJGPro flag has been replaced

  const headerType = useCallback(() => {
    if (headerimage && isJGPro) {
      return 'sitebuilder';
    }
    if (headerimage) {
      return 'branded';
    }
    return 'consumer';
  }, [headerimage, isJGPro]);

  useEffect(() => {
    loadClient({
      headerVariant: headerType(),
      footerVariant: headerimage ? 'branded' : 'full',
    });
  }, [headerimage, headerType]);

  return (
    <TrackingProvider
      analytics={analytics}
      defaultTrackingData={{
        page_id: basePageData?.data?.page?.legacyId,
        event_label: basePageData?.data?.page?.legacyId,
        event_category: basePageData?.data?.page?.type,
      }}
    >
      <div data-qa="page-wrapper">
        <PageView trackingData={baseTrackingData}>{children}</PageView>
      </div>
    </TrackingProvider>
  );
};

export default Page;
